import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Wrapper = styled.div`
  ${fonts.libreBaskerville};
  p {
    text-align: center;
  }
`

export const Content = styled.div`
  padding: 30px 50px;
  margin: 0 auto;
  height: 334px;
  width: 860px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("${ASSETS_PATH}/pages/Dashboard/images/payment-banner-01.jpg");
`

export const Text = styled.div`
  width: 300px;
  font-size: 40px;
`

export const UpgradeLabel = styled.div`
  margin-top: 35px;
  color: ${colors.pink};
  font-size: 25px;
`

const TopBanner = props => (
  <Wrapper>
    <Content>
      <Text>
        Engage your {props.parent ? 'children' : 'students'} and inspire a love of writing
      </Text>
      <UpgradeLabel>
        Upgrade now
      </UpgradeLabel>
    </Content>
    <p>Please email <a href='mailto:teachers@nightzookeeper.com'>teachers@nightzookeeper.com</a> to request a quote.</p>
  </Wrapper>
)

TopBanner.propTypes = {
  parent: PropTypes.bool
}

TopBanner.defaultProps = {
  parent: false
}

export default TopBanner
